import { store, itiHttpService} from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { authService } from './../../shared/services/auth.service';
import { API } from '@/shared/api';
import { Reply } from '@/shared/dtos/reply';

@Module({
  namespaced: true,
  name: 'ReplyModule',
  store,
  dynamic: true,
})
class ReplyModule extends VuexModule {

    public replys: Reply[] = [];

    @Mutation
    public setReplys(replys: Reply[]) {
        this.replys = replys;
    }

    @Action
    public async getReplys(datos: any[]) {
        const res = await itiHttpService.get(API.replys + '/Get?postId=' + datos[0] + '&ambitId=' + datos[1], false,false, false)
        .catch(() => this.context.commit('setReplys', []));
        this.context.commit('setReplys', res);
    }

    @Action
    public async saveReply(reply: Reply) {
        reply.id = 0;
        return await itiHttpService.post(API.replys + '/Post', reply.toJson()).then(() => this.getReplys([reply.postId, reply.ambitId]));
    }

    @Action
    public async deleteReply(id: number) {
        this.replys.splice(this.replys.findIndex((reply: Reply) => reply.id == id), 1);
        return await itiHttpService.delete(API.replys + '/Delete?id=' + id,'');
    }

    @Action
    public async updateReply(reply: Reply) {
        return await itiHttpService.put(API.replys + '/Put', JSON.stringify(reply));
    }

}
export default getModule(ReplyModule);
